import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { Button } from '../ui/button'
import TrialPlansModal from '../trial-modal/trial-plans-modal'

interface Props {
  isOpen: boolean
  onHandleSkip: () => void
}

export default function WelcomeStartTrialModal({
  isOpen,
  onHandleSkip,
}: Props) {
  const [applyDiscount] = useState(false)
  const [isOpenTrialPlans, setIsOpenTrialPlans] = useState(false)

  return (
    <>
      <Dialog
        open={isOpen}
        onOpenChange={(v) => {
          if (!v) {
            onHandleSkip()
          }
        }}
      >
        <DialogContent className="max-w-[480px] !p-8 rounded-lg">
          <DialogHeader>
            <DialogTitle className="md:text-2xl">
              You have been upgraded!
            </DialogTitle>
          </DialogHeader>
          <div>
            <p>
              Welcome to your 3 day free trial of our{' '}
              <span className="font-bold">Professional Plan.</span> Enjoy full
              access to Hydra Score’s wealth of water rights and land use data.
            </p>
          </div>
          <DialogFooter className="flex sm:flex-col gap-4">
            <Button className="h-14 w-full" onClick={onHandleSkip}>
              Begin Trial
            </Button>
            <div className="flex flex-col gap-1 items-center text-center">
              <p>Report generation requires a paid subscription.</p>
              <Button
                variant={'ghost'}
                onClick={() => {
                  setIsOpenTrialPlans(true)
                }}
              >
                View Plans
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <TrialPlansModal
        isOpen={isOpenTrialPlans}
        isDiscount={applyDiscount}
        onOpenChange={setIsOpenTrialPlans}
      />
    </>
  )
}
